import Icon, { IconType } from 'components/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { setSidebarVisible } from 'redux/mode/actions';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as S from './styles';

const SidebarToggle = () => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const { sidebarVisible, isMobile } = useSelector((r: RootReducer) => {
		return {
			sidebarVisible: r.mode.sidebarVisible,
			isMobile: selectIsMobile(r.mode),
		};
	});

	return (
		<S.Base isMobile={isMobile} onClick={() => dispatch(setSidebarVisible(!sidebarVisible))}>
			<Icon
				type={sidebarVisible ? IconType.LEFT_PANE_VISIBLE : IconType.LEFT_PANE_HIDDEN}
				width={isMobile ? 28 : 16}
				height={isMobile ? 28 : 16}
				color={theme.gray[1000]}
			/>
		</S.Base>
	);
};

export default SidebarToggle;
